import { Visibility } from "@mui/icons-material";
import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";

function JobCardDetails({ ticketValue }) {
    return (
        <>
            <Box>
                <Typography>Opportunity</Typography>
            </Box>
            <Box>
                <Grid container spacing={2}>
                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                opportunity date time:
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {
                                    ticketValue?.opportunity
                                        ?.opportunity_date_time
                                }
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                installation type:
                            </Typography>

                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.installation_type}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Rate:
                            </Typography>

                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.rate}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                avg annual bill :
                            </Typography>

                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.avg_annual_bill}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                monthly cost :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.monthly_cost}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Aannual increases Percentage :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {
                                    ticketValue?.opportunity
                                        ?.annual_increases_percentage
                                }
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Roof Materials :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.roof_materials}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Shading :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.shading}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Panels :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.panels}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                number of panels :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.number_of_panels}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                panel wattage :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.panel_wattage}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                File Path :
                            </Typography>
                            {ticketValue?.opportunity?.pdf_path && (
                                <a
                                    href={ticketValue?.opportunity?.pdf_path}
                                    target="_blank"
                                >
                                    <Button startIcon={<Visibility />}>
                                        Show PDF
                                    </Button>
                                </a>
                            )}
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Status :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.status}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Job type :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.job_type}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                paydown Percentage :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.paydownPercentage}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                is online monitoring :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity
                                    ?.is_online_monitoring === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                inverter_type :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.inverter_type === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                how many ft trench dirt :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity
                                    ?.how_many_ft_trench_dirt === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                system size :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.system_size} K.W
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                is finance :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.is_finance === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                productivity offset :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity
                                    ?.productivity_offset === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                federal tax :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.federal_tax
                                    ? "$" +
                                      ticketValue?.opportunity?.federal_tax
                                    : ""}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Apr :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity?.apr}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                is online monitoring :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity
                                    ?.is_online_monitoring === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                is online monitoring :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity
                                    ?.is_online_monitoring === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                is online monitoring :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.opportunity
                                    ?.is_online_monitoring === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default JobCardDetails;
